import type { OrganizationDetail } from 'models';
import type { ReactNode } from 'react';
import { AxiosErrorHandler, Skeleton } from 'ui';
import { useOrganizationDetailQuery } from '../queries';

type P = {
  children: (organization?: OrganizationDetail) => ReactNode;
  id?: string;
  skeleton?: ReactNode;
};

const OrganizationProvider = ({ children, id, skeleton }: P) => {
  const {
    data: organization,
    error,
    isLoading: isLoadingOrganization,
  } = useOrganizationDetailQuery({
    organizationId: id,
  });
  const isLoading = Boolean(id) && isLoadingOrganization;

  return (
    <AxiosErrorHandler error={error}>
      {isLoading ? (skeleton ?? <Skeleton active />) : children(organization)}
    </AxiosErrorHandler>
  );
};

export default OrganizationProvider;
